<template v-if="!loading && posts.length > 0">
  <div class="ctpx-short-sec insta-sec">
    <div class="row">
      <div class="col-12">
        <h3 class="display-hero-sub lead">
          <a href="https://www.instagram.com/cotopaxi/" target="_blank"
            >@Cotopaxi</a
          >
        </h3>
      </div>
      <!--.col-12-->
    </div>
    <!--.row-->
    <div class="row">
      <div class="col insta-feed">
        <swiper
          :modules="modules"
          :slidesPerView="'auto'"
          :space-between="12"
          navigation
          :breakpoints="{
            '640': {
              slidesPerView: 1.5,
            },
            '768': {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }"
          @swiper="onSwiper"
        >
          <template v-for="post in posts.slice(0, 8)">
            <swiper-slide>
              <a :href="post.permalink" target="__blank">
                <img :src="post.media_url" />
              </a>
            </swiper-slide>
          </template>
        </swiper>
      </div>
    </div>
    <!--.row-->
  </div>
  <!--.ctpx-short-sec-->
</template>

<script src="./ctrl-instagram.js"></script>
